export default "__VITE_ASSET__da26c702__"